<template>
    <div v-if="vo">
        <el-dialog :title="$tx('hygl.components.meetingDetail', '会议详情')" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px" :before-close="handleClose">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane :label="$tx('hygl.components.meetingInfo', '会议信息')" name="first">
                    <el-form :model="vo">
                        <div class="el-table el-table--fit el-table--border">
                            <div class="el-table__body-wrapper">
                                <table cellspacing="0" cellpadding="0" class="el-table__body">
                                    <tbody>
                                        <tr>
                                            <td v-field-lbl="'flSubject'" class="el-table__cell tdlbl tdw17" colspan="1">会议主题</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.flSubject }}</span>
                                            </td>
                                            <td v-field-lbl="'meetingName'" class="el-table__cell tdlbl tdw17" colspan="1">会议室名称</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.meetPlace }}</span>
                                            </td>
                                            <!-- <td class="el-table__cell tdlbl tdw17" colspan="1">会议时间</td>
                      <td class="el-table__cell tdcont tdw33" colspan="2">
                        <span v-if="vo.startTime">{{ vo.startTime.substr(0,16) +'至'+ vo.endTime.substr(0,16) }}</span>
                      </td> -->
                                        </tr>
                                        <tr>
                                            <td v-field-lbl="'startTime'" class="el-table__cell tdlbl tdw17" colspan="1">开始时间</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.startTime }}</span>
                                                <!-- <span>{{ vo.startTime.substr(0,16) }}</span> -->
                                            </td>
                                            <td v-field-lbl="'endTime'" class="el-table__cell tdlbl tdw17" colspan="1">结束时间</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.endTime }}</span>
                                                <!-- <span>{{ vo.endTime.substr(0,16) }}</span> -->
                                            </td>
                                        </tr>
                                        <tr>
                                            <td v-field-lbl="'flCreateDept'" class="el-table__cell tdlbl tdw17" colspan="1">召集部门</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.flCreateDept }}</span>
                                            </td>
                                            <td v-field-lbl="'flCreator'" class="el-table__cell tdlbl tdw17" colspan="1">召集人</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.flCreator }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td v-text-lbl="'phone'" class="el-table__cell tdlbl tdw17" colspan="1">联系电话</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.flCreatorPhone }}</span>
                                            </td>
                                            <td v-field-lbl="'meetHost'" class="el-table__cell tdlbl tdw17" colspan="1">会议主持人</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.meetHost }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td v-field-lbl="'attendLeader'" class="el-table__cell tdlbl tdw17" colspan="1">出席领导</td>
                                            <td class="el-table__cell tdcont tdw83" colspan="5">
                                                <span>{{ vo.attendLeader }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td ref="tdlbl_会议主题" v-field-lbl="'flContent'" class="el-table__cell tdlbl tdw17" colspan="1">会议内容</td>
                                            <td class="el-table__cell tdcont tdw83" colspan="5">
                                                <!-- <el-input v-model=" vo.flContent" :rows="1" readonly style="border:0px;"></el-input> -->
                                                <span>{{ vo.flContent }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td ref="tdlbl_会议主题" v-field-lbl="'meetingAttach'" class="el-table__cell tdlbl tdw17" colspan="1">会议附件</td>
                                            <td class="el-table__cell tdcont tdw83" colspan="5">
                                                <div v-for="item in attachs" :key="item">
                                                    <span class="hoverSpan" style="cursor: pointer; color: #409efe" @click="downloadFuc(item.id)">{{ item.fileName }}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane :label="$tx('hygl.components.meetingAgenda', '会议议题')" name="second">
                    <!-- <p style="width: 96%; margin: 0 2%;"><span style="float: left;margin-bottom: 10px;">会议议题</span></p> -->
                    <el-table border :data="tableDataYT" style="margin-bottom: 20px">
                        <el-table-column :label="$tx('fields.index', '序号')" align="center" type="index" />
                        <el-table-column :label="$tx('hygl.components.topics', '议题')" align="left" prop="flSubject" />
                        <el-table-column :label="$tx('hygl.components.reporter', '汇报人')" width="80" align="left" prop="flCreator" />
                        <el-table-column :label="$tx('hygl.components.reportTime', '汇报时长(分钟)')" align="center" width="110" prop="reportTime" />
                        <el-table-column :label="$tx('hygl.components.durationTime', '讨论时长(分钟)')" width="110" align="center" prop="talkTime" />
                        <el-table-column :label="$tx('hygl.components.attendees', '列席人员')" width="200" align="left" prop="attendStoolName" />
                        <el-table-column :label="$tx('hygl.components.attachNum', '附件数量')" width="65" align="center">
                            <template #default="scope">
                                <span style="cursor: pointer" @click="downloadFucYt(scope.row.id, scope.row.passenger.ytNum)">{{ scope.row.passenger.ytNum }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane :label="$tx('hygl.components.meetinger', '会议人员')" name="third" class="hyryBox">
                    <div class="toolBar clearfix">
                        <el-button-group class="l">
                            <!-- <el-button size="small" :class="activeTypeP===3?'active':''" @click="getPeopleFuc('')">全部</el-button> -->
                            <el-button v-text-lbl="'noReceived'" size="small" :class="activeTypeP === 0 || activeType === '0' ? 'active' : ''" @click="getPeopleFuc('0')">未回执</el-button>
                            <el-button v-text-lbl="'participation'" size="small" :class="activeTypeP === 1 || activeType === '1' ? 'active' : ''" @click="getPeopleFuc('1')">参会</el-button>
                            <el-button v-text-lbl="'noParticipation'" size="small" :class="activeTypeP === 2 || activeType === '2' ? 'active' : ''" @click="getPeopleFuc('2')">不参会</el-button>
                        </el-button-group>
                        <div style="float: right; display: flex">
                            <el-input v-model="searchTextP" size="small" :placeholder="$tx('hygl.components.searching', '搜索...')" style="width: 200px" @keyup.enter.native="getPeopleFuc(activeTypeP)">
                                <el-button slot="append" icon="el-icon-search" style="width: 30px" @click.native="getPeopleFuc(activeTypeP)" />
                            </el-input>
                            <div>
                                <el-button v-text-lbl="'addMeetingPerson'" :class="transTime(vo.startTime, vo.endTime) === '未开始' ? 'active' : ''" size="small" style="margin-left: 16px" :disabled="transTime(vo.startTime, vo.endTime) === '未开始' ? false : true" @click="transTime(vo.startTime, vo.endTime) === '未开始' ? innerVisibleclick() : ''">添加参会人员</el-button>
                            </div>
                        </div>
                    </div>
                    <el-table border :data="tableDataP" style="width: 100%; margin-bottom: 20px; max-height: 267px; overflow: auto">
                        <el-table-column :label="$tx('fields.index', '序号')" type="index" align="center" width="45">
                            <template #default="scope">
                                <span>{{ scope.$index + (pageNumP - 1) * pageSizeP + 1 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$tx('fields.name', '姓名')" prop="userName" align="left" />
                        <el-table-column :label="$tx('hygl.components.duties', '职务')" prop="userPost" align="left" width="100" />
                        <el-table-column :label="$tx('hygl.components.depart', '部门')" prop="userDept" align="left" width="100" />
                        <el-table-column :label="$tx('hygl.components.phone', '联系电话')" prop="phone" align="center" width="100" />
                        <el-table-column :label="$tx('hygl.components.personType', '人员类型')" prop="meetPersonType" align="center" width="110">
                            <template #default="scope">
                                <span>{{ scope.row.meetPersonType === 1 ? $tx('hygl.components.insider', '内部人员') : scope.row.meetPersonType === 2 ? $tx('hygl.components.outsiders', '外部人员') : $tx('hygl.components.leader', '领导') }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="activeTypeP === 2" :label="$tx('hygl.components.notAttendingReason', '不参会原因')" prop="regReason" align="center" width="200" />
                    </el-table>
                    <el-pagination align="right" :current-page="currentPage" :page-sizes="[5, 10]" :page-size="5" layout="total, sizes, prev, pager, next, jumper" :total="totalP" @size-change="handleSizeChange1" @current-change="handleCurrentChange1" />
                </el-tab-pane>
                <el-tab-pane :label="$tx('hygl.components.sginInfo', '签到信息')" name="fourth" class="hyryBox">
                    <div class="toolBar clearfix">
                        <el-button-group class="l">
                            <!-- <el-button size="small" :class="activeType===2?'active':''" @click="getPeopleSignFuc('')">全部</el-button> -->
                            <el-button v-text-lbl="'signIn'" size="small" :class="activeType === 1 || activeType === '1' ? 'active' : ''" @click="getPeopleSignFuc('1')">已签到</el-button>
                            <el-button v-text-lbl="'noSignIn'" size="small" :class="activeType === 0 || activeType === '0' ? 'active' : ''" @click="getPeopleSignFuc('0')">未签到</el-button>
                        </el-button-group>
                        <el-input v-model="searchTextM" size="small" :placeholder="$tx('hygl.components.searching', '搜索...')" style="width: 200px; float: right" @keyup.enter.native="getPeopleSignFuc(activeType)">
                            <el-button slot="append" icon="el-icon-search" style="width: 30px" @click.native="getPeopleSignFuc(activeType)" />
                        </el-input>
                    </div>
                    <el-table border :data="tableData" style="width: 100%; margin-bottom: 20px; max-height: 267px; overflow: auto">
                        <el-table-column :label="$tx('fields.index', '序号')" type="index" align="center" width="45">
                            <template #default="scope">
                                <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$tx('fields.name', '姓名')" prop="userName" width="80" align="left" />
                        <el-table-column :label="$tx('hygl.components.depart', '部门')" prop="userDept" align="left" width="100" />
                        <el-table-column :label="$tx('hygl.components.phone', '联系电话')" prop="phone" align="center" width="100" />
                        <el-table-column :label="$tx('fields.remark', '备注')" prop="remark" align="left" />
                        <el-table-column v-if="activeType !== 0" :label="$tx('hygl.components.signTime', '签到时间')" prop="signTime" align="center" width="150" />
                    </el-table>
                    <el-pagination align="right" :current-page="currentPage4" :page-sizes="[5, 10]" :page-size="5" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </el-tab-pane>
                <el-tab-pane :label="$tx('hygl.components.meetingTj', '会议统计')" name="fifth">
                    <div style="display: flex">
                        <div style="width: 50%">
                            <EchartAnnular chart-id="mainQiandao" legend-top="bottom" legend-left="center" :alldata="dataQD" :radius="radius" is-legend="true" is-label-line="true" is-label="true" :legend-icon="legendIcon" :color="color" :title="titleQD" formatter="{b} : {d}%" label-formatter="{b} : {d}%" :legend-formatter="legendFormatterQD" style="width: 405px; height: 350px" />
                        </div>
                        <div style="width: 50%">
                            <EchartAnnular chart-id="mainBaoming" :alldata="dataBM" :radius="radius" legend-top="bottom" legend-left="center" is-legend="true" is-label-line="true" is-label="true" :legend-icon="legendIcon" :color="color" :title="titleBM" formatter="{b} : {d}%" label-formatter="{b} : {d}%" :legend-formatter="legendFormatterBM" style="width: 405px; height: 350px" />
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <span slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'close'" icon="el-icon-close" @click="dialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 添加参会人员 -->
        <el-dialog width="600px" :title="$tx('hygl.components.participants', '参会人员')" :visible.sync="innerVisible" append-to-body>
            <el-form :model="voPeople">
                <div class="el-table el-table--fit el-table--border">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" style="border: 1px solid #ebeef5" class="el-table__body">
                            <tbody>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-text-lbl="'personType'">类型</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="人员类型" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-radio-group v-model="meetPersonType" @change="addObjchange">
                                                    <el-radio v-text-lbl="'insider'" :label="'1'">内部人员</el-radio>
                                                    <el-radio v-text-lbl="'outsiders'" :label="'2'">外部人员</el-radio>
                                                </el-radio-group>
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'name'">姓名</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <ValidationProvider v-if="meetPersonType !== null" ref="ValidationProvider" v-slot="{ errors }" name="姓名" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input v-if="meetPersonType == '1'" v-model="addObj.userName" v-select-dialog="'staff'" readonly :root-org-code="vo.orgCode" :placeholder="$tx('hygl.components.orgPlaceholder', '请选择机构员工')" name="orgStaff" resize="none" />
                                                <el-input v-if="meetPersonType == '2'" v-model="addObj.userName" :placeholder="$tx('hygl.components.namePlaceholder', '请输入姓名')" @change="renyuanshuru" />
                                                <!-- :org-id="vo.orgFullId.split('-')[1]" -->
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-text-lbl="'depart'">部门</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <ValidationProvider v-if="addObj.userDept !== null" ref="ValidationProvider" v-slot="{ errors }" name="部门" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input v-model="addObj.userDept" :readonly="meetPersonType === '1'" :placeholder="meetPersonType === '1' ? $tx('hygl.components.autoGet', '自动获取') : $tx('hygl.components.departPlaceholder', '请输入部门')" @change="bumen" />
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-text-lbl="'telphone'">电话</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <ValidationProvider v-if="addObj.phone !== null" ref="ValidationProvider" v-slot="{ errors }" name="电话" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input v-model="addObj.phone" :readonly="meetPersonType === '1'" :placeholder="meetPersonType === '1' ? $tx('hygl.components.autoGet', '自动获取') : $tx('hygl.components.telphonePlaceholder', '请输入电话')" @change="dianhua" />
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required" />
                                        <span v-text-lbl="'position'">职位</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <el-input v-model="addObj.userPost" :readonly="meetPersonType === '1'" :placeholder="meetPersonType === '1' ? $tx('hygl.components.autoGet', '自动获取') : $tx('hygl.components.positionPlaceholder', '请输入职位')" @change="zhiwei" />
                                    </td>
                                </tr>

                                <tr>
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required" />
                                        <span v-text-lbl="'remark'">备注</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <el-input v-model="addObj.remark" :rows="2" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'cancel'" @click="closeclick">取消</el-button>
                <el-button v-pageBtn-lbl="'save'" type="primary" @click="savePeopleFuc">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    props: {
        rowObj: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'components',
            loginUser: this.$store.getters.loginUser,
            titleQD: {
                name: this.$tx('hygl.components.tjScan', '签到统计')
            },
            titleBM: {
                name: this.$tx('hygl.components.bmtj', '报名统计')
            },
            activeType: 1,
            activeTypeP: 0,
            currentPage: 0,
            currentPage4: 1,
            radius: ['0', '50%'],
            legendIcon: 'circle',
            activeName: 'first',
            tabActiveSign: 'all',
            tableData: [],
            tableDataYT: [],
            tableDataP: [],
            tableDataPeople: [],
            tableDataSign: [],
            dialogVisible: false,
            vo: {},
            color: ['#41A1FF', '#3ECBCB', '#F2667D'],
            dataQD: [],
            dataBM: [],
            legendFormatterBM: {
                orient: 'vertical',
                left: 'left',
                // data: ['参会', '不参会', '未回执'],
                data: [this.$tx('hygl.components.participation', '参会'), this.$tx('hygl.components.noParticipation', '不参会'), this.$tx('hygl.components.noReceived', '未回执')]
            },
            legendFormatterQD: {
                orient: 'vertical',
                left: 'left',
                // data: ['已签到', '未签到']
                data: [this.$tx('hygl.components.signIn', '已签到'), this.$tx('hygl.components.noSignIn', '未签到')]
            },
            attachs: null,
            resultobj: '',
            meetingId: '',
            showViewType: '',
            searchTextP: '',
            searchTextM: '',
            dialogFormVisible: false,
            tableSign: false,
            tableSignFlag: '',
            tableSignF: '',
            pageNum: 1,
            pageSize: 5,
            pageNumP: 1,
            pageSizeP: 5,
            total: 0,
            totalP: 0,
            innerVisible: false,
            meetPersonType: '1',
            addObj: {},
            bumenid: ''
        }
    },
    computed: {
        ...mapGetters(['loginUser'])
    },
    watch: {
        meetPersonType(val) {
            this.addObj = {
                regStatus: 1,
                remark: '',
                email: '',
                passenger: {},
                personId: '',
                userAccount: ''
            }
        },
        activeTypeP(val) {
            console.log(val, 'activeTypeP')
            this.pageNumP = 1
        },
        activeType(val) {},
        innerVisible(val) {
            if (!val) {
                this.addObj = {}
                this.bumenid = ''
            }
        }
    },
    created() {
        if (this.vo.startTime) {
            this.vo.startTime = this.vo.startTime.substr(0, 16)
        } else if (this.vo.endTime) {
            this.vo.endTime = this.vo.endTime.substr(0, 16)
        }
    },
    beforeDestroy() {
        this.$bus.$off('clicklog')
    },
    mounted() {
        this.$bus.$on('clicklog', (resultobj) => {
            this.activeName = 'first'
            this.dialogVisible = true
            this.meetingId = resultobj
            console.log(resultobj)
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    busiDataIds: resultobj
                },
                url: `/hygl/attach/queryAttachList?urlsearch=orgCode:${this.loginUser.orgCode}`
            }).then((result) => {
                if (result.code === 'success') {
                    this.attachs = result.body.listdata
                    console.log(this.attachs)
                } else {
                    this.$message.error(result.message)
                }
            })
            this.vo = {}
            this.initGetById(resultobj)
            // var attachurl = process.env.VUE_APP_BASE_API + '/hygl/ytap/downloadById?attachIds=' + id + '&httpPort=' + location.port
            // window.open(attachurl, '_blank')
        })
    },
    methods: {
        transTime(start, end) {
            var date = new Date()

            var startTime = new Date(start)
            var endTime = new Date(end)
            if (startTime > date) {
                return '未开始'
            } else if (endTime < date) {
                return '已结束'
            } else if (startTime < date) {
                return '进行中'
            }
        },
        // 下载议题附件

        downloadFucYt(id, num) {
            if (num > 0) {
                var attachurl = process.env.VUE_APP_BASE_API + '/hygl/ytap/downloadByBusiDataId?busiDataId=' + id + '&httpPort=' + location.port
                window.open(attachurl, '_blank')
            }
        },
        // 下载会议题件
        downloadFuc(id, num) {
            var attachurl = process.env.VUE_APP_BASE_API + '/hygl/hyap/downloadById?attachIds=' + id + '&httpPort=' + location.port
            window.open(attachurl, '_blank')
        },
        handleCurrentChange(val) {
            this.pageNum = val
            this.getPeopleSignFuc(this.activeType)
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.getPeopleSignFuc(this.activeType)
        },
        handleCurrentChange1(val) {
            this.pageNumP = val
            this.getPeopleFuc(this.activeTypeP)
        },
        handleSizeChange1(val) {
            this.pageSizeP = val
            this.getPeopleFuc(this.activeTypeP)
        },
        // 参会人员
        addObjchange(val) {
            this.meetPersonType = null
            this.$nextTick(() => {
                this.meetPersonType = val
            })
        },
        async innerVisibleclick() {
            this.innerVisible = true
            // const arr = []
            // // 对一人多个部门选出当前登录人所分配角色进行处理
            // for (let i = 0; i < this.loginUser.staffList.length; i++) {
            //     const res = await this.$app.getById('/base/orgTreeMgr/getOrganizationById', this.loginUser.staffList[i].orgFullId.split('-')[1])
            //     arr.push(res.body.vo.passenger.HyglManager)
            // }
            // arr.forEach(item => {
            //     item.forEach(val => {
            //         if (val.personId === this.loginUser.personId) {
            //             if (this.bumenid !== '') this.bumenid += ','
            //             this.bumenid += val.orgFullId.split('-')[1]
            //         }
            //     })
            // })
        },
        // 添加人员
        async savePeopleFuc() {
            if (!this.addObj.userName) {
                this.$confirm(this.$tx('hygl.message.selectPerson2', '请选择人员！'), this.$tx('common.operationTip', '操作提示'), {
                    confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                    type: 'warning'
                })
                return false
            }
            if (!this.addObj.userDept) {
                this.$confirm(this.$tx('hygl.message.departNull', '部门不能为空！'), this.$tx('common.operationTip', '操作提示'), {
                    confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                    type: 'warning'
                })
                // this.$message.error('请选择人员！')
                return false
            }
            var re = /^1\d{10}$/ // 正则表达式
            // debugger
            if (!this.addObj.phone) {
                this.$confirm(this.$tx('hygl.message.phoneNull', '电话不能为空！'), this.$tx('common.operationTip', '操作提示'), {
                    confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                    type: 'warning'
                })
                return false
            }
            if (!re.test(this.addObj.phone)) {
                this.$confirm(this.$tx('hygl.message.phoneInvalid', '人员电话无效，请输入11位手机号!'), this.$tx('common.operationTip', '操作提示'), {
                    confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                    type: 'warning'
                })
                return false
            }
            this.$set(this.addObj, 'meetId', this.meetingId)
            this.$set(this.addObj, 'meetPersonType', this.meetPersonType)
            // this.$set(this.addObj, 'regStatus', this.regStatus)
            // this.$set(this.addObj, 'meetPersonType', this.meetPersonType)
            const res = await this.$app.insert('/hygl/meetPeople/insert', this.addObj)
            if (res.code === 'success') {
                this.$message.success(res.message)
                this.innerVisible = false
                this.addObj = {}
                if (this.meetPersonType === '1') {
                    this.getPeopleFuc(0)
                }
                if (this.meetPersonType === '2') {
                    this.getPeopleFuc(1)
                }
                // this.$bus.emit('refreshListData')
            } else {
                this.$message.error(res.message)
                this.innerVisible = false
            }
        },
        renyuanshuru(val) {
            this.addObj.name = val
            this.$set(this.addObj, 'personId', val)
            // this.$set(this.addObj, 'regStatus', 1)
            this.addObj.regStatus = 1
            // this.meetPersonType = ''
            console.log('输入人', val)
        },
        bumen(val) {
            this.addObj.userDept = val
            console.log('输入部门', val)
        },
        dianhua(val) {
            this.addObj.phone = val
            console.log('输入电话', val)
        },
        zhiwei(val) {
            this.addObj.userPost = val
            console.log('输入职位', val)
        },
        closeclick() {
            this.innerVisible = false
            this.meetPersonType = '1'
            this.addObj = {
                regStatus: 1,
                remark: '',
                email: '',
                passenger: {},
                personId: '',
                userAccount: ''
            }
            // this.meetPersonType = ''
        },
        // 选择人员
        onSelectStaffCompleted(selectedNodes, attr) {
            let selected = ''
            selectedNodes.forEach(function (node) {
                if (selected !== '') selected += '、'
                selected = node
            })
            this.addObj.meetPersonType = '1'
            const num = selected.title.indexOf('\\')
            const dept = selected.title.substring(0, num)
            var newArr = this.tableDataP.filter((v) => v.personId == selected.personId)
            if (newArr.length > 0) {
                this.$message.error(this.$tx('hygl.message.hasPerson', '该人员已存在'))
                return
            }
            this.$set(this.addObj, 'userName', selected.name)
            this.$set(this.addObj, 'phone', selected.mobile)
            this.$set(this.addObj, 'userPost', selected.positionName)
            this.$set(this.addObj, 'userDept', dept)
            this.$set(this.addObj, 'email', selected.email)
            this.$set(this.addObj, 'userAccount', selected.account)
            this.$set(this.addObj, 'personId', selected.personId)
            this.addObj.regStatus = 0
            // this.$set(this.addObj, 'meetId', this.meetingId)
        },
        // 会议人员
        async getPeopleFuc(type) {
            let status = '0'
            if (type === '' || type === 3) {
                this.activeTypeP = 3
                status = ''
            } else if (type === '2' || type === 2) {
                this.activeTypeP = 2
                status = '2'
            } else if (type === '1' || type === 1) {
                this.activeTypeP = 1
                status = '1'
            } else if (type === '0' || type === 0) {
                this.activeTypeP = 0
                status = '0' + ',' + '3'
            }
            const fileSearch = {
                pageNum: this.pageNumP,
                pageSize: this.pageSizeP,
                orderBy: 'orgFullOrderNo asc',
                searchAndOr: 'or',
                searchMap: {
                    userName: this.searchTextP
                }
            }
            const res = await this.$app.listdata(`/hygl/meetPeople/listdata?urlsearch=meetId:${this.meetingId};regStatus:${status}`, fileSearch)
            if (res.code === 'success') {
                this.tableDataP = res.body.pageInfo.list
                this.totalP = res.body.pageInfo.total
                this.tableDataP.forEach((item) => {
                    if (item.userPost === null || item.userPost === 'null') {
                        item.userPost = ''
                    }
                })
            } else {
                this.$message.error(res.message)
            }
        },
        // 签到人员
        async getPeopleSignFuc(type) {
            this.activeType = 1
            let status = '0'
            if (type === '' || type === 2) {
                this.activeType = 2
                status = ''
            } else if (type === '1' || type === 1) {
                this.activeType = 1
                status = '1'
            } else if (type === '0' || type === 0) {
                this.activeType = 0
                status = '0'
            }
            const fileSearch = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                orderBy: 'orgFullOrderNo asc',
                searchAndOr: 'or',
                searchMap: {
                    userName: this.searchTextM
                }
            }
            const res = await this.$app.listdata(`/hygl/meetPeople/listdata?urlsearch=meetId:${this.meetingId};signStatus:${status};meetPersonType:1`, fileSearch)
            if (res.code === 'success') {
                this.tableData = res.body.pageInfo.list
                this.total = res.body.pageInfo.total
                console.log(this.tableData)
            } else {
                this.$message.error(res.message)
            }
        },
        // 获取会议信息
        async initGetById(resultobj) {
            const res = await this.$app.getById('/hygl/hyap/getById', resultobj)
            if (res.code === 'success') {
                this.vo = res.body.vo
                // if (this.vo.ytObject) {
                this.tableDataYT = JSON.parse(this.vo.ytObject)
                // }
            } else {
                this.$message.error(res.message)
            }
        },
        handleClick(tab, event) {
            console.log(tab, event)
            this.activeName = tab.name
            if (tab.name === 'third') {
                this.getPeopleFuc('0')
            } else if (tab.name === 'fourth') {
                this.getPeopleSignFuc('1')
            } else if (tab.name === 'fifth') {
                this.getPie()
            }
        },
        // 饼状图
        async getPie() {
            const _this = this
            await this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                url: `/hygl/hyap/getStatisticsNum?id=${this.meetingId}`
            }).then((res) => {
                if (res.code === 'success') {
                    console.log(res.body.meetNum)
                    const reg = res.body.regList
                    const sign = res.body.signList
                    const regList = [
                        { value: reg[0].reg0, name: this.$tx('hygl.components.noReceived', '未回执') },
                        { value: reg[0].reg1, name: this.$tx('hygl.components.participation', '参会') },
                        { value: reg[0].reg2, name: this.$tx('hygl.components.noParticipation', '不参会') }
                    ]
                    const signList = [
                        { value: sign[0].sign0, name: this.$tx('hygl.components.noSignIn', '未签到') },
                        { value: sign[0].sign1, name: this.$tx('hygl.components.signIn', '已签到') }
                    ]
                    this.dataQD = signList
                    this.dataBM = regList
                    console.log(regList, signList)
                } else {
                    _this.$message.error(res.message)
                }
            })
        },
        onListDataBeforeLoad($scope, qparams) {
            qparams.orderBy = 'orgFullOrderNo asc'
        }
    }
}
</script>

<style scoped lang="scss">
.el-dialog .el-dialog__body .el-tabs--top {
    margin-top: 0;
    // height: 400px;
}
/deep/.el-table__empty-block {
    border-bottom: 1px solid #eeeeee;
}
/deep/.el-tabs__content::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
}
/deep/.el-tabs__content {
    height: 361px;
    overflow-y: auto;
}
/deep/.el-table-toolbar-right {
    display: none;
}
/deep/.data-table-container .el-table {
    overflow-y: auto;
    height: 266px;
}
.toolBar {
    margin-bottom: 10px;
}
.active {
    background: #409eff !important;
    color: #fff !important;
    border-color: #409eff !important;
}
.hoverSpan:hover {
    color: #409eff;
}
.hyryBox {
    /deep/ .el-table::before {
        content: none;
    }
}
</style>
